import { Link } from "react-router-dom";

const DISCLAIMER =
  "Werkio is not legal, tax, immigration, HR, or labor compliance advice.";
const RESPONSIBILITY =
  "Employers are responsible for determining which documents are required and how long records must be retained.";
const CAPABILITIES =
  "Werkio provides secure storage, access controls, audit trails, expiration tracking, and retention tools.";

interface LegalPageProps {
  title: string;
  description: string;
}

function LegalPage({ title, description }: LegalPageProps) {
  return (
    <main className="mx-auto min-h-screen max-w-3xl px-6 py-16 text-navy-deep">
      <Link to="/" className="text-sm font-semibold text-blue-700 hover:underline">
        ← Back to Werkio
      </Link>
      <h1 className="mt-8 text-3xl font-bold">{title}</h1>
      <p className="mt-3 text-muted-foreground">{description}</p>
      <div className="mt-8 space-y-4 rounded-xl border bg-card-white p-6 text-sm leading-6">
        <p>{DISCLAIMER}</p>
        <p>{RESPONSIBILITY}</p>
        <p>{CAPABILITIES}</p>
        <p className="text-muted-foreground">
          This page is a policy placeholder pending review and publication of final terms by
          qualified counsel.
        </p>
      </div>
    </main>
  );
}

export function PrivacyPage() {
  return <LegalPage title="Privacy" description="How Werkio handles company and worker data." />;
}

export function TermsPage() {
  return <LegalPage title="Terms of Service" description="Terms governing use of Werkio." />;
}

export function DpaPage() {
  return <LegalPage title="Data Processing Addendum" description="Data processing responsibilities and safeguards." />;
}

export function SecurityPage() {
  return <LegalPage title="Security" description="Werkio security controls and shared responsibilities." />;
}

/** Hidden while Worker Documents remains gated pending legal review. */
export function DocumentRetentionPage() {
  return (
    <main className="mx-auto flex min-h-screen max-w-3xl flex-col items-center justify-center px-6 py-16 text-center text-navy-deep">
      <h1 className="text-2xl font-bold">Page not found</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        The page you requested does not exist or is not available.
      </p>
      <Link to="/" className="mt-6 text-sm font-semibold text-blue-700 hover:underline">
        ← Back to Werkio
      </Link>
    </main>
  );
}
